// typescript
import {Form} from "react-bootstrap";
import Calendar from "react-calendar";
import React, {useEffect, useState} from "react";
import {FormLabelRequiredAsterisk} from "Components/Form/FormLabelRequiredAsterisk";
import {ActivitySession} from "Model/Activity/ActivitySession";
import {MultiValue} from "react-select";
import {SelectOptionType} from "Model/Select/SelectOption";
import {DAY_NAMES_TO_NUMBERS} from "Model/Date/Day";
import {TileDisabledFunc, Value} from "react-calendar/dist/cjs/shared/types";
import {getNextWeekTuesday} from "Services/ActivitySession/ActivitySessionCalendar";

interface Props {
    session: ActivitySession | null,
    selectedDays: MultiValue<SelectOptionType> | null,
    onChange: (value: Value) => void,
    initDate: string,
    endDate: string,
    numberOfDays: number,
    todayOverride?: string // nueva prop opcional (ej: "2026-02-23")
}

export const InitDateCalendar: React.FC<Props> = (props) => {

    const now = props.todayOverride
        ? new Date(props.todayOverride)
        : process.env.REACT_APP_FAKE_TODAY
            ? new Date(process.env.REACT_APP_FAKE_TODAY)
            : new Date();
    now.setHours(0,0,0,0);

    const defaultActivityInitDate = (props.initDate && new Date(props.initDate) < now) ? now : new Date(props.initDate);
    defaultActivityInitDate.setHours(0,0,0,0);

    const [activityInitDate, setActivityInitDate] = useState<Date>(defaultActivityInitDate);
    const [activityEndDate, setActivityEndDate] = useState<Date>(new Date(props.endDate));
    const [minDate, setMinDate] = useState<Date | null>(null);
    const [value, setValue] = useState<Date|Value|null>(null);
    const [daysArray, setDaysArray] = useState<string[]>([]);

    const calcMinDate = () => {
        if (!props.selectedDays) {
            return;
        }

        let initDate = activityInitDate;

        if (now >= activityInitDate) {
            initDate = getNextWeekTuesday(now);
        }
        setMinDate(initDate);
        setActivityInitDate(initDate);

        const newDaysArray: string[] = [];
        props.selectedDays?.map(day => newDaysArray.push(DAY_NAMES_TO_NUMBERS[day.label.toLowerCase()].toString()));
        setDaysArray(newDaysArray);
    };

    const isDayDisabled : TileDisabledFunc = ({date}) => {
        return daysArray.indexOf(date.getDay().toString()) === -1;
    };

    const onDaySelected = (value: Value) => {
        setValue(value);
        props.onChange(value);
    };

    useEffect(() => {
        calcMinDate();
    }, [props.selectedDays, props.todayOverride]);

    useEffect(() => {
        props.onChange(value);
    }, [value]);

    useEffect(() => {
        if(!minDate){
            setValue(null);
            return;
        }
    }, [minDate]);

    return (
        <>
            <Form.Label>
                Fecha de inicio <FormLabelRequiredAsterisk/>
            </Form.Label>

            {
                minDate &&
                <>
                    <Calendar
                        onChange={(e) => onDaySelected(e)}
                        value={value}
                        locale={"es-ES"}
                        minDate={minDate}
                        maxDate={activityEndDate}
                        defaultActiveStartDate={activityInitDate}
                        tileDisabled={isDayDisabled}
                    />
                </>
            }
        </>
    );
};
